import React from 'react';
import { VictoryLabel, VictoryVoronoiContainer, VictoryTooltip } from 'victory';
import { alpha } from '@material-ui/core';
import { themeWithoutDir as theme } from '~/modules/App/withRootTheme';
import { TOOLTIP_FIELDS } from './useTooltipLabels';

const TOOLTIP_CORNER_RADIUS = 5;
const TOOLTIP_POINTER_LENGTH = 0;
const TOOLTIP_CENTER_OFFSET = { y: 50 };
const GROUP_BY_LABEL_OFFSET = 1;

const baseTextStyle = {
  fill: theme.palette.text.white,
  fontSize: `${parseFloat(theme.typography.caption.fontSize) *
    theme.spacing(2)}px`,
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  textAnchor: 'start'
};

const tooltipStyles = {
  text: {
    base: baseTextStyle,
    bold: { ...baseTextStyle, fontWeight: 700 }
  },
  flyout: {
    fill: alpha(theme.palette.grey[700], 0.9),
    stroke: 'none'
  },
  flyoutPadding: {
    top: theme.spacing(1.5),
    bottom: theme.spacing(1.5),
    left: theme.spacing(1),
    right: theme.spacing(1)
  }
};

const getTooltipStyleArray = selectedProblem => {
  const fieldIndex = TOOLTIP_FIELDS.indexOf(selectedProblem);
  const boldIndex = fieldIndex >= 0 ? fieldIndex + GROUP_BY_LABEL_OFFSET : -1;
  const totalLines = TOOLTIP_FIELDS.length + GROUP_BY_LABEL_OFFSET;

  return Array.from({ length: totalLines }, (_, index) =>
    index === boldIndex ? tooltipStyles.text.bold : tooltipStyles.text.base
  );
};

export const createBOAChartTooltipContainer = ({
  labels,
  voronoiPadding,
  voronoiBlacklist,
  selectedProblem
}) => {
  const tooltipStyleArray = getTooltipStyleArray(selectedProblem);

  const tooltipLabelComponent = (
    <VictoryLabel lineHeight={1.44} style={tooltipStyleArray} />
  );

  const containerLabelComponent = (
    <VictoryTooltip
      style={tooltipStyles.text.bold}
      flyoutStyle={tooltipStyles.flyout}
      flyoutPadding={tooltipStyles.flyoutPadding}
      cornerRadius={TOOLTIP_CORNER_RADIUS}
      pointerLength={TOOLTIP_POINTER_LENGTH}
      centerOffset={TOOLTIP_CENTER_OFFSET}
      constrainToVisibleArea
      labelComponent={tooltipLabelComponent}
    />
  );

  return (
    <VictoryVoronoiContainer
      aria-labelledby="bench-detail-panel"
      mouseFollowTooltips
      labels={labels}
      labelComponent={containerLabelComponent}
      voronoiDimension="x"
      voronoiPadding={voronoiPadding}
      voronoiBlacklist={voronoiBlacklist}
    />
  );
};
